<template>
	<div id="app" class="App">
		<navigation-mobile v-if="isMobile" />
		<navigation v-else />
		<div class="c">
			<div v-if="!isMobile" class="a" />
			<div :class="getClassName" :style="backgroundImageStyle" />
		</div>
		<router-view class="content" />
		<footer-comp />
		<cookie-banner />
	</div>
</template>

<script>
import Navigation from '@/components/Navigation.vue'
import NavigationMobile from '@/components/NavigationMobile.vue'
import FooterComp from '@/components/FooterComp.vue'
import CookieBanner from '@/components/CookieBanner.vue'
import mainBackground from './assets/backgroundGeneral/mainBackground.jpg'
import contactBackground from './assets/backgroundGeneral/background1.jpg'
import prefight1 from './assets/grad1/prefight1.jpg'
import infight1 from './assets/grad1/infight1.jpg'
import wrestling1 from './assets/grad1/wrestling1.jpg'
import grappling1 from './assets/grad1/grappling1.jpg'
import weapons3new from './assets/grad3/weapons3new.jpg'
import postfight1a from './assets/grad1/postfight1a.jpg'
import postfight1b from './assets/grad1/postfight1b.jpg'
import prefight2 from './assets/grad2/prefight2.jpg'
import infight2 from './assets/grad2/infight2.jpg'
import wrestling2 from './assets/grad2/wrestling2.jpg'
import grappling2 from './assets/grad2/grappling2.jpg'
import weapons2 from './assets/grad2/weapons2.jpg'
import postfight2a from './assets/grad2/postfight2a.jpg'
import prefight3 from './assets/grad3/prefight3.jpg'
import infight3 from './assets/grad3/infight3.jpg'
import wrestling3 from './assets/grad3/wrestling3.jpg'
import grappling3 from './assets/grad3/grappling3.jpg'
import weapons3 from './assets/grad3/weapons3.jpg'
import postfight3a from './assets/grad3/postfight3a.jpg'
import prefight4 from './assets/grad4/prefight4.jpg'
import infight4 from './assets/grad4/infight4.jpg'
import wrestling4 from './assets/grad4/wrestling4.jpg'
import grappling4 from './assets/grad4/grappling4.jpg'
import weapons4 from './assets/grad4/weapons4.jpg'
import postfight4a from './assets/grad4/postfight4a.jpg'
import editorial1 from './assets/editorial/editorial1.jpg'
import editorial2 from './assets/editorial/editorial2.jpg'
import editorial3 from './assets/editorial/editorial3.jpg'
import editorial4 from './assets/editorial/editorial4.jpg'
import editorial5 from './assets/editorial/editorial5.jpg'
import editorial6 from './assets/editorial/editorial6.jpg'
import editorial7 from './assets/editorial/editorial7.jpg'
import editorial8 from './assets/editorial/editorial8.jpg'
import editorial9 from './assets/editorial/editorial9.jpg'

export default {
	name: 'App',
	components: {
		Navigation,
		NavigationMobile,
		FooterComp,
		CookieBanner
	},
	data() {
		return {
			isMobile: window.innerWidth <= 1024,
			mappedBackgrounds: {
				DasSystem: mainBackground,
				Aufbau: mainBackground,
				Ausbilder: mainBackground,
				Ausbildungsgrade: mainBackground,
				BasicQualificationCourse: mainBackground,
				Grad1Prefight: prefight1,
				Grad1Infight: infight1,
				Grad1Wrestling: wrestling1,
				Grad1Grappling: grappling1,
				Grad1Weapons: weapons2,
				Grad1Postfight1: postfight1a,
				Grad1Postfight2: postfight1b,
				Grad2Prefight: prefight2,
				Grad2Infight: infight2,
				Grad2Wrestling: wrestling2,
				Grad2Grappling: grappling2,
				Grad2Weapons: weapons3,
				Grad2Postfight1: postfight2a,
				Grad3Prefight: prefight3,
				Grad3Infight: infight3,
				Grad3Wrestling: wrestling3,
				Grad3Grappling: grappling3,
				Grad3Weapons: weapons3new,
				Grad3Postfight1: postfight3a,
				Grad4Prefight: prefight4,
				Grad4Infight: infight4,
				Grad4Wrestling: wrestling4,
				Grad4Grappling: grappling4,
				Grad4Weapons: weapons4,
				Grad4Postfight1: postfight4a,
				Editorial: mainBackground,
				Editorial1: editorial1,
				Editorial2: editorial2,
				Editorial3: editorial3,
				Editorial4: editorial4,
				Editorial5: editorial5,
				Editorial6: editorial6,
				Editorial7: editorial7,
				Editorial8: editorial8,
				Editorial9: editorial9,
				FAQ: mainBackground,
				Referenzen: mainBackground,
				Newsletter: mainBackground,
				Meinungen: mainBackground,
				Medien: mainBackground,
				Impressum: mainBackground,
				Kontakt: contactBackground,
				Datenschutz: mainBackground
			}
		}
	},
	methods: {
		handleScreenSizeChange() {
			this.isMobile = window.innerWidth <= 1024
		}
	},
	computed: {
		backgroundImage() {
			return this.mappedBackgrounds[this.$route.name]
		},
		backgroundImageStyle() {
			let image = ''
			if (this.isMobile) {
				image = `linear-gradient(90deg, rgba(0,0,0,0.7) 0%, rgba(0,0,0,0.5) 100%), url('${this.backgroundImage}')`
			} else {
				image = `linear-gradient(90deg, black 18%, transparent 45%), url('${this.backgroundImage}')`
			}
			return {
				backgroundRepeat: 'no-repeat',
				backgroundPosition: 'right',
				backgroundSize: 'cover',
				backgroundImage: image
			}
		},
		getClassName() {
			return this.isMobile
				? 'page-background-image--mobile'
				: 'page-background-image'
		}
	},
	created() {
		window.addEventListener('resize', this.handleScreenSizeChange)
	},
	beforeDestroy() {
		window.removeEventListener('resize', this.handleScreenSizeChange)
	}
}
</script>

<style lang="stylus">
@import './styl/global.styl'
@import './styl/responsive.styl'
.a {
	background: black;
	flex-grow: 2;
	width: 40vw;
	height: 100vh;
}
.page-background-image {
	background-color: black;
	flex-grow: 1;
	width: 60vw;
	height: 100vh;
}
.page-background-image--mobile {
	background-color: black;
	flex-grow: 1;
	width: 100vw;
	height: 100vh;
}
.c {
	display: flex;
	position: fixed;
}
.content {
	position: relative;
	min-height: 100vh;
}
h1 {
	position: relative;
}
</style>
